import Vue from 'vue';
import axios from 'axios';
import fb from '@/firebaseConfig.js';

import { arrayUnion, arrayRemove } from 'vuex-easy-firestore';

const spacesModule = {
  //  Easy VUEX firestore configuration
  firestorePath: 'workspaces',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'workspaces',
  statePropName: 'workspacesData',
  namespaced: true, // automatically added
  state: {
    guestProfiles: {},
    currentWorkspaceId: null
  },
  getters: {
    workspaces: state => {
      console.log('calc workspaces');
      if (!state.workspacesData) {
        return [];
      }
      const workspaces = Object.values(state.workspacesData);
      return workspaces;
    },
    currentWorkspace: state => {
      console.log('calc currentWorkspace');
      if (state.currentWorkspaceId) {
        return state.workspacesData[state.currentWorkspaceId];
      } else {
        return {};
      }
    },
    workspaceContexts: (state, getters, rootState, rootGetters) => {
      console.log('calc workspaceContexts');
      //  Get all contexts from userWorkspaceLite based on currentWorkspaceId
      const workspaceId = state.currentWorkspaceId;
      const allUserDocuments = rootState.userWorkspaceLite.allUserDocuments;
      try {
        return Object.values(allUserDocuments).filter(
          c => c.workspace == workspaceId && c.type == 'context'
        );
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    userPermissionIds: (state, getters, rootState, rootGetters) => {
      console.log('calc userPermissionIds');
      const ids = [];
      //add userId to the list of ids
      if (!rootGetters['auth/isUser']) {
        console.log('could not find auth for userPermissionIds');
        return ids;
      }
      const userId = rootGetters['auth/userId'];
      ids.push(userId);

      //add all workspaces and groups
      getters.workspaces.forEach(workspace => {
        if (Object.keys(workspace.members).includes(userId)) {
          ids.push(workspace.id);
          Object.values(workspace.groups).forEach(group => {
            if (group.members.includes(userId)) {
              ids.push(group.id);
            }
          });
        }
      });
      return ids;
    },
    collaboratorDirectory: (state, getters) => {
      console.log('calc collab directory');
      const members = {};
      Object.assign(members, state.guestProfiles);
      Object.values(getters.workspaces).forEach(w => {
        Object.assign(members, w.members);
      });
      return members;
    },
    guestWorkspaces: (state, getters, rootState, rootGetters) => {
      return []; // TODO: Setup guest workspace document in UserWorkspaceLite collection
      // //get all the variables we will need
      // const { workspaces } = getters;
      // let userContextsLite = rootGetters['userContextsLite/contextsLite'];

      // //workspaces will be used to populate with some data
      // let contextLiteWorkspaces = rootGetters['userContextsLite/contextLiteWorkspaces'];
      // const contextLiteWorkspaceKeys = Object.keys(contextLiteWorkspaces);
      // const emptyProfile = {
      //   id: 'workspaceNoteFound',
      //   profile: { avatar: null, name: 'UnKnown Workspace' }
      // };
      // console.log('contextLiteWorkspaces', contextLiteWorkspaces);
      // //return empy if userContexts lite is undefined
      // if (userContextsLite == undefined) {
      //   return [];
      // }
      // console.log('userContextsLite', userContextsLite);
      // //filter userContextsLite by those that aren't in any of your current workspaces
      // const workspaceIds = workspaces.map(workspace => workspace.id);
      // userContextsLite = Object.values(userContextsLite).filter(contextLite => {
      //   return !workspaceIds.includes(contextLite.workspace);
      // });

      // //  make a map of guest workspaces with contexts
      // const guestWorkspaces = { 0: { profile: emptyProfile, contexts: [] } };
      // userContextsLite.forEach(context => {
      //   if (contextLiteWorkspaceKeys.includes(context.workspace)) {
      //     console.log('profile', contextLiteWorkspaces[context.workspace].profile);
      //     //guestWorkspaces[context.workspace].profile = contextLiteWorkspaces[context.workspace].profile;
      //     if (!guestWorkspaces[context.workspace]) {
      //       guestWorkspaces[context.workspace] = {
      //         profile: contextLiteWorkspaces[context.workspace].profile,
      //         contexts: [context]
      //       };
      //     } else {
      //       guestWorkspaces[context.workspace].contexts.push(context);
      //     }
      //     //userContextsLite[index].workspace = contextLiteWorkspaces[context.workspace].profile;
      //   } else {
      //     guestWorkspaces[0].contexts.push(context);
      //   }
      // });
      // if (!guestWorkspaces[0].contexts.length) {
      //   //  No contexts in unknown workspace, remove it;
      //   delete guestWorkspaces[0];
      // }
      // // //add a field to them for workspace that includes profile
      // // userContextsLite.forEach((context, index) => {
      // //   if (contextLiteWorkspaceKeys.includes(context.workspace)) {
      // //     console.log('profile', contextLiteWorkspaces[context.workspace].profile);
      // //     userContextsLite[index].workspace = contextLiteWorkspaces[context.workspace].profile;
      // //   } else {
      // //     userContextsLite[index].workspace = emptyProfile.profile;
      // //   }
      // // });
      // return guestWorkspaces;
    }
  },
  mutations: {
    addProfileToGuestProfiles(state, { profile }) {
      Vue.set(state.guestProfiles, profile.id, profile);
    },
    setWorkspaceId(state, val) {
      console.log('set workspace id', val);
      state.currentWorkspaceId = val;
    }
  },
  actions: {
    subscribeToWorkspaces({ dispatch, rootGetters }) {
      return new Promise(async (resolve, reject) => {
        //get userId and throw an error if there are any problems getting the user ID
        if (!rootGetters['auth/isUser']) {
          reject('auth/isUser is set to false');
        }
        const userId = rootGetters['auth/userId'];

        //open a subscription to the users workspaces
        try {
          await dispatch('openDBChannel', { where: [[`members.${userId}.id`, '==', userId]] });
          resolve('subscribed to workspace');
        } catch (e) {
          reject(e);
        }
      });
    },
    unsubscribeToWorkspaces({ dispatch }) {
      console.log('unsubscribe to user spaces');
      dispatch('closeDBChannel', { clearModule: true });
    },
    setWorkspaceId({ commit, dispatch }, id) {
      commit('setWorkspaceId', id);
      //  update user to reflect last open workspace
      dispatch('auth/updateProfile', { lastWorkspaceId: id }, { root: true });
    },
    async createNewWorkspace({ dispatch, getters, rootGetters }, { name = '' }) {
      //get userId and throw an error if there are any problems getting the user ID
      if (!rootGetters['auth/isUser']) {
        throw 'auth/isUser is set to false';
      }
      if (typeof name != 'string') {
        throw 'the name field is not a string';
      }
      const userId = rootGetters['auth/userId'];
      //add members to user profile
      const userProfile = rootGetters['auth/profile'];
      userProfile.id = userId;

      //new workspaceId
      const workspaceId = getters['dbRef'].doc().id;

      //generate the final workspace doc to be added
      const finalDoc = {
        id: workspaceId,
        profile: {
          name,
          avatar: null
        },
        admins: [userId],
        subscriptionInfo: {
          status: 'active',
          currentPlan: 'Beta Hero',
          createdDate: new Date()
        },
        tags: {},
        members: {},
        groups: {},
        folders: {},
        contexts: []
      };

      //add the current userProfile to members
      finalDoc.members[userId] = userProfile;
      console.log('new workspace', finalDoc);
      try {
        dispatch(
          'userWorkspaceLite/createUserWorkspaceLite',
          { userId, workspaceId },
          { root: true }
        );
        await dispatch('insert', finalDoc);
        dispatch('track/trackEvent', { action: 'Create new workspace' }, { root: true });
        return workspaceId;
      } catch (e) {
        console.log('error adding new workspace', e);
        throw new Error(e);
      }
    },
    updateWorkspaceName({ dispatch }, { name, workspaceId }) {
      //return error if proper fields weren't provided
      if (name == undefined) {
        throw 'no name field was provided for the updating the workspace';
      }
      if (workspaceId == undefined) {
        throw 'no workspaceId input field was provided for updating the workspace';
      }

      const profile = { name: name };
      //update vuex and database with vuex-easy-firestore
      dispatch('patch', { id: workspaceId, profile });
      dispatch('track/trackEvent', { action: 'Update workspace name' }, { root: true });
    },
    addWorkspaceMember({ dispatch }, { workspaceId, user }) {
      if (workspaceId == undefined) {
        throw 'input workspaceId was not provided cannot add the user to a workspace please check your inputs and try again';
      }
      if (user == undefined) {
        throw 'input user was not provided so the author cannot be added to the workspace chekc your inputs and try again';
      }
      if (!('id' in user)) {
        throw 'input user does not contain key id please check your inputs and try again';
      }
      //create an update object with the users data
      const updateObject = {
        id: workspaceId,
        members: {}
      };
      updateObject.members[user.id] = user;
      console.log('workspace updateObject', updateObject);
      //update vuex and firestore
      dispatch('patch', updateObject);
      const url = fb.paths.function + 'createNewUWL';
      axios.post(url, {
        user: { id: user.uid, name: user.displayName, avatar: user.photoUrl || false },
        workspaceId
      });
      dispatch('track/trackEvent', { action: 'Add workspace member' }, { root: true });
    },
    removeWorkspaceMember({ dispatch }, { workspaceId, authorId }) {
      if (workspaceId == undefined) {
        throw 'input workspaceId was not provided cannot remove the user from a workspace please check your inputs and try again';
      }
      if (authorId == undefined) {
        throw 'input authorId was not provided so the author cannot be removed from, the workspace chekc your inputs and try again';
      }

      //create an update object with the users data
      const updateString = `${workspaceId}.members.${authorId}`;

      //update vuex and firestore
      dispatch('delete', updateString);
      dispatch('track/trackEvent', { action: 'Remove workspace member' }, { root: true });
    },
    fetchGuestProfiles({}, { userIds, workspaceId }) {
      console.log('fetch guest profiles');
      return new Promise((resolve, reject) => {
        const url = fb.paths.function + 'getUserProfiles';
        axios
          .post(url, { userIds, workspaceId })
          .then(result => {
            console.log('fetched', result.data);
            resolve(result.data);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    addProfilesToGuestMemberProfiles({ commit }, { profileArray }) {
      console.log('add profiles to guest member profiles');
      profileArray.forEach(profile => {
        commit('addProfileToGuestProfiles', { profile: profile });
      });
    },
    addFolder(
      { dispatch, getters, rootGetters, state },
      { workspaceId, text = 'New Folder', parentFolderId, permissions, newFolderId }
    ) {
      //get userId and throw an error if there are any problems getting the user ID
      if (!rootGetters['auth/isUser']) {
        return 'auth/isUser is set to false';
      }
      const userId = rootGetters['auth/userId'];
      //throw an error if user ID is not available
      if (workspaceId == undefined) {
        throw 'no workspaceId was provided for the new folder review your function inputs and try again';
      }
      //setup defaults for all other inputs (besides workspaceId)
      let localPermissions = permissions;
      let localParentFolderId = parentFolderId;
      let localNewFolderId = newFolderId;
      let localText = text;

      //define default for permissions
      if (localPermissions == undefined) {
        if (localParentFolderId == undefined) {
          localPermissions = {
            owner: userId,
            editing: [workspaceId],
            viewing: []
          };
        } else {
          const workspace = state.workspacesData[workspaceId];
          const parentFolder = workspace.folders[localParentFolderId];
          localPermissions = parentFolder.permissions;
          localPermissions.owner = userId;
        }
      }
      //define a default for parent folder
      if (localParentFolderId == undefined) {
        localParentFolderId = workspaceId;
      }

      //define default for new id
      if (localNewFolderId == undefined) {
        localNewFolderId = getters['dbRef'].doc().id;
      }
      console.log('localnewFolderId', localNewFolderId);

      //create the update object for the addition of the folder
      const folderUpdate = {};
      folderUpdate[localNewFolderId] = {
        id: localNewFolderId,
        text: localText,
        parent: localParentFolderId,
        contexts: [],
        permissions: localPermissions
      };

      dispatch('patch', { id: workspaceId, folders: folderUpdate });
      dispatch('track/trackEvent', { action: 'Create new folder' }, { root: true });
      return localNewFolderId;
    },
    deleteFolder({ dispatch, rootGetters }, { folderId, workspaceId }) {
      if (workspaceId == undefined) {
        throw 'no workspaceId was provided for the folder name update review your function inputs and try again';
      }
      if (folderId == undefined) {
        throw 'no folderId was provided for the folder name update, review your function inputs and try again';
      }

      //get the actual workspace because we will need the folders, return an error if there is a problem
      const workspace = rootGetters['workspaces/workspaces'].find(
        workspace => workspace.id === workspaceId
      );
      if (workspace == undefined) {
        throw `could not find the requested workspace ${workspaceId} please ensure user is subscribed to the workspace`;
      }

      //get the folder that is supposed to be deleted
      const mainFolder = workspace.folders[folderId];
      //make an array to hold all the folders that need deleted
      const foldersToDelete = [mainFolder];
      //populate folders to delete by recursivly adding all the children
      findAllChildren(mainFolder, workspace.folders);

      //recurrsively delete all of the associated contexts and folders
      foldersToDelete.forEach(folder => {
        //delete all the contexts
        folder.contexts.forEach(contextId => {
          dispatch('context/deleteContext', { contextId }, { root: true });
        });
        //delete the folder
        const updateString = `${workspaceId}.folders.${folder.id}`;
        dispatch('delete', updateString);
      });

      function findAllChildren(parentFolder, folderMap) {
        Object.values(folderMap).forEach(folder => {
          if (folder.parent === parentFolder.id) {
            foldersToDelete.push(folder);
            findAllChildren(folder, folderMap);
          }
        });
      }
      dispatch('track/trackEvent', { action: 'Delete folder' }, { root: true });
    },
    updateFolderName({ dispatch }, { folderId, workspaceId, text }) {
      //get necessary items throw an error if not provided
      if (workspaceId == undefined) {
        throw 'no workspaceId was provided for the folder name update review your function inputs and try again';
      }
      if (folderId == undefined) {
        throw 'no folderId was provided for the folder name update, review your function inputs and try again';
      }
      if (text == undefined) {
        throw 'no text inpujt was provided for the folder name udpate, review your function inputs and try again';
      }

      //create the update object for the new folder
      const folderUpdate = {};
      folderUpdate[folderId] = {
        text
      };

      dispatch('patch', { id: workspaceId, folders: folderUpdate });
    },
    updateFolderParent({ dispatch }, { folderId, workspaceId, parentFolderId }) {
      //get necessary items throw an error if not provided
      if (workspaceId == undefined) {
        throw 'no workspaceId was provided for the folder parent update review your function inputs and try again';
      }
      if (folderId == undefined) {
        throw 'no folderId was provided for the folder parent update, review your function inputs and try again';
      }
      if (parentFolderId == undefined) {
        throw 'no parentId input was provided for the folder parent udpate, review your function inputs and try again';
      }

      //create the update object for the new folder
      const folderUpdate = {};
      folderUpdate[folderId] = {
        parent: parentFolderId
      };

      dispatch('patch', { id: workspaceId, folders: folderUpdate });
    },
    updateFolderPermissionsField({ dispatch }, { folderId, workspaceId, fieldKey, fieldValue }) {
      //get necessary items throw an error if not provided
      if (workspaceId == undefined) {
        throw 'no workspaceId was provided for the folder permissions review your function inputs and try again';
      }
      if (folderId == undefined) {
        throw 'no folderId was provided for the folder permissions, review your function inputs and try again';
      }
      const possibleKeyValues = ['owner', 'editing', 'viewing'];
      if (!possibleKeyValues.includes(fieldKey)) {
        throw `input fieldKey can only be one of the following values: ${possibleKeyValues.toString()}; please check your input "fieldKey" and try again`;
      }
      if (fieldValue == undefined) {
        throw `input field value was not provided, please check your inputs and try again`;
      }
      const arrayFields = ['editing', 'viewing'];
      if (arrayFields.includes(fieldKey) && fieldValue.constructor !== Array) {
        throw `if input fieldKey is equal to ${fieldKey}, then input fieldValue must be an array,  please check that fieldValue is an array and try again`;
      }
      //create the update object
      //create the update object
      const folderUpdate = { id: workspaceId };
      folderUpdate.folders = {};
      folderUpdate.folders[folderId] = {};
      folderUpdate.folders[folderId].permissions = {};
      folderUpdate.folders[folderId].permissions[fieldKey] = fieldValue;

      dispatch('patch', folderUpdate);
    },
    addContextToFolder({ dispatch }, { workspaceId, folderId, contextId }) {
      console.log('addingContext to folder');
      const folderUpdate = { id: workspaceId };
      if (folderId === workspaceId) {
        folderUpdate.contexts = arrayUnion(contextId);
      } else {
        folderUpdate.folders = {};
        folderUpdate.folders[folderId] = {};
        folderUpdate.folders[folderId].contexts = arrayUnion(contextId);
      }
      console.log('folderUpdate', folderUpdate);
      dispatch('patch', folderUpdate);
    },
    moveContextToFolder({ dispatch }, { workspaceId, currentFolderId, newFolderId, contextId }) {
      console.log('moveContextToFolder to folder');
      const folderUpdate = { id: workspaceId };
      if (newFolderId === workspaceId) {
        folderUpdate.contexts = arrayUnion(contextId);
      } else {
        folderUpdate.folders = {};
        folderUpdate.folders[newFolderId] = {};
        folderUpdate.folders[newFolderId].contexts = arrayUnion(contextId);
      }

      if (currentFolderId === workspaceId) {
        folderUpdate.contexts = arrayRemove(contextId);
      } else {
        folderUpdate.folders = {};
        folderUpdate.folders[currentFolderId] = {};
        folderUpdate.folders[currentFolderId].contexts = arrayRemove(contextId);
      }

      console.log('moveContextToFolder', folderUpdate);
      dispatch('patch', folderUpdate);
    },
    addNewResourceTag({ dispatch, getters }, { workspaceId, tagText }) {
      //get a new id for tag
      const tagId = getters['dbRef'].doc().id;
      //construct the object for the tag
      const tagObject = { id: tagId, resources: [], text: tagText };

      //build the update object
      const update = { id: workspaceId, resourceTags: {} };
      update.resourceTags[tagId] = tagObject;

      //push the update to the workspace
      dispatch('patch', update);
    },
    deleteResourceTag({ dispatch }, { workspaceId, tagId }) {
      const deleteString = `${workspaceId}.resourceTags.${tagId}`;
      dispatch('delete', deleteString);
    },
    renameResourceTag({ dispatch }, { workspaceId, tagId, tagText }) {
      //build the update object
      const update = { id: workspaceId, resourceTags: {} };
      update.resourceTags[tagId] = {};
      update.resourceTags[tagId].text = tagText;

      //push the update to the workspace
      dispatch('patch', update);
    }
  }
};

export default spacesModule;
